<template>
  <v-row justify="center" no-gutters>
    <v-col col="12">
      <v-card v-if="isCategoryMode" flat>
        <v-card-title class="text-center justify-center pb-0"
          >نوبت‌ها</v-card-title
        >

        <v-row class="pa-2" no-gutters>
          <v-col class="pa-2" cols="12">
            <v-card
              class="pa-4 rounded-xl"
              outlined
              style="position: sticky; top: 100px"
            >
              <v-card-title>انتخاب دسته‌بندی</v-card-title>

              <div
                v-for="(cat, i) in value[getItemsReservations]"
                :key="i"
                class="mb-2"
              >
                <v-btn
                  :text="
                    value[getItemsReservations][selectedCategory].id !== cat.id
                  "
                  block
                  class="rounded-lg justify-start text-right"
                  color="#0d8ddc"
                  dark
                  depressed
                  @click="selectCategory(i)"
                >
                  {{ cat.name }}
                </v-btn>
              </div>
            </v-card>
          </v-col>

          <v-col class="pa-2" cols="12">
            <appointment-reserve-view
              :value="value[getItemsReservations][selectedCategory]"
              only-dates
            />
          </v-col>
        </v-row>
      </v-card>

      <v-card v-else class="rounded-0" flat>
        <v-card-title v-if="onlyDates">
          <v-avatar class="ml-2">
            <v-img :alt="value.name" :src="value.picture" contain />
          </v-avatar>
          {{ value.name }}
        </v-card-title>

        <template v-else>
          <v-card-title
            v-show="!!value.title"
            class="text-center justify-center"
          >
            {{ value.title }}
          </v-card-title>
          <p v-show="!!value.description" class="text-center">
            {{ value.description }}
          </p>
        </template>

        <v-row
          v-if="!!displayDates && !!displayDates.length"
          justify="center"
          no-gutters
        >
          <v-col class="pa-2" cols="12">
            <swiper-wrapper
              id="appointment-slider"
              ref="swiper"
              :centered-slides="!onlyDates"
              :loop="false"
              :real-index.sync="selectedCategory"
              :slides-per-view="3.6"
              :space-between="10"
              swipe-to
              wrapper-class="category-slider"
            >
              <div
                v-for="(item, i) in displayDates"
                :key="i"
                :class="{ 'active-cat': selectedCategory === i }"
                class="swiper-slide text-center"
                style="user-select: none"
                @click="getSwiper"
              >
                <v-card
                  class="d-flex align-center flex-column justify-center mx-auto rounded-lg"
                  height="56"
                  outlined
                  width="100%"
                  @click="selectedCategory = i"
                >
                  {{ datetime(item.value, "date") }}
                </v-card>
                <span class="mt-1 d-inline-block">{{ item.text }}</span>
              </div>
            </swiper-wrapper>
          </v-col>

          <v-col class="pt-4 text-center" col="12">
            <v-progress-circular
              v-if="loading"
              class="mx-auto"
              color="blue"
              indeterminate
              size="40"
              width="5"
            />

            <v-row v-else class="pa-1 position-relative" no-gutters>
              <v-col
                v-for="(item, i) in computedTickets"
                :key="i"
                class="p-1"
                cols="12"
              >
                <template v-if="!!item.length">
                  <v-card-title class="break-word medium-font">
                    نوبت‌های {{ i | timeText }}
                  </v-card-title>

                  <div class="d-flex flex-wrap px-1 justify-center">
                    <template v-for="(time, j) in item">
                      <v-card
                        :class="{
                          'unavailable-time': time.status !== 'notReserved',
                        }"
                        :disabled="time.status !== 'notReserved'"
                        :outlined="time.status !== 'notReserved'"
                        class="rounded-lg mb-3 time-slot mx-1"
                        link
                        min-width="100"
                        outlined
                      >
                        <div
                          v-if="
                            !!time.discount &&
                            !!Number(time.discount) &&
                            i !== 'expired'
                          "
                          class="warning discount-chip pa-1"
                        >
                          <span>٪</span>
                          {{ use_lang(price(time.discount)) }}
                        </div>

                        <v-card-subtitle class="pa-1">{{
                          time.title
                        }}</v-card-subtitle>
                        <span class="justify-center pa-1 d-block">{{
                          use_lang(getTime(time.time))
                        }}</span>

                        <v-card-subtitle class="px-1 py-0 text-center mt-0">
                          {{ use_lang(price(time.price)) }}
                          <span style="font-size: xx-small">﷼</span>
                        </v-card-subtitle>
                      </v-card>
                    </template>
                  </div>
                </template>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import SwiperWrapper from "@/view/pages/businessPage/components/cm/swiperWrapper.vue";
import { mapState } from "vuex";

export default {
  name: "appointmentReserveView",

  components: { SwiperWrapper },

  props: {
    value: Object,
    onlyDates: Boolean,
  },

  filters: {
    dateText(date) {
      const moment = require("moment");
      moment.locale("fa");
      return moment(date).format("dddd");
    },
    timeText(text) {
      switch (text) {
        case "expired":
          return "گذشته";
        case "morning":
          return "صبح";
        case "afternoon":
          return "بعداز ظهر";
        case "evening":
          return "عصر";
      }
    },
  },

  data: () => ({
    selectedCategory: 0,
    categories: [],
    loading: false,
    showCart: false,
  }),

  computed: {
    ...mapState("localstorage", ["createQrID"]),
    computedTickets() {
      const moment = require("moment");

      const initTimes = (data) => {
        let obj = {
          expired: [],
          morning: [],
          afternoon: [],
          evening: [],
        };

        data?.forEach((item) => {
          if (item.status === "expired" || moment(item.time).isBefore())
            obj.expired.push(item);
          else if (
            moment(item.time).isBetween(
              `${item.value} 08:00:00`,
              `${item.value} 14:00:00`,
              "hour"
            )
          )
            obj.morning.push(item);
          else if (moment(item.time).isBefore(`${item.value} 19:00:00`, "hour"))
            obj.afternoon.push(item);
          else obj.evening.push(item);
        });

        return obj;
      };

      return this.onlyDates
        ? initTimes(this.value.reservations[this.selectedCategory].times)
        : initTimes(this.displayDates[this.selectedCategory].times);
    },
    isCategoryMode() {
      return (
        !!this.value &&
        !!this.value.items &&
        !!this.value.items?.every((item) => !!item.reservations) &&
        !this.onlyDates
      );
    },
    getItemsReservations() {
      return this.onlyDates ? "reservations" : "items";
    },
    displayDates() {
      return this.value[this.getItemsReservations];
    },
  },

  watch: {
    value: {
      deep: true,
      handler(val) {
        this.selectedCategory = 0;
        this.$forceUpdate();
      },
    },
  },

  methods: {
    getSwiper() {
      let s = document.getElementById("appointment-slider");
      s.swiper.slideTo(s.swiper.clickedIndex, 300);
    },
    selectCategory(index) {
      this.selectedCategory = index;
      this.$forceUpdate();

      this.rerender = false;
      this.$nextTick(() => {
        this.rerender = true;
      });
    },
  },
};
</script>

<style scoped>
.active-cat >>> .v-card {
  background-color: #0d8ddc;
  color: #fff;
}

.active-cat >>> span {
  color: #0d8ddc;
}
</style>
